import tagTester from './_tagTester.js';

export default tagTester('Symbol');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isSymbol.js
// module id = 90
// module chunks = 0